import React from 'react';
import {Text, Title} from '@priority-software/priority-style-react';
import {ReactComponent as EmptyListSVG} from './assets/empty-list.svg';
import {ReactComponent as SearchVisual} from './assets/search-visual.svg';
import {getEmptyStateText, getEmptyStateTitle} from './utils';
import {texts} from '../../../../texts';
import aiTexts from '../../../../../../Localization/AISearch/texts';
import {RuleType} from '../../../../enums';
import {createDataTestId} from '../../../../../../utils/dataTestId';
import {supportAIBlock} from '../../../../utils';
import styles from './EmptyState.module.scss';

type Props = {
    searchValue: string;
    hasFilters: boolean;
    type: RuleType;
};

export const EmptyState = ({searchValue = '', hasFilters, type}: Props) => {
    const hasSearchQuery = !!searchValue || hasFilters;
    const supportAI = supportAIBlock();

    return (
        <div className={styles.component} {...createDataTestId('Empty-state', false)}>
            <div className={styles.componentIcon}>
                <EmptyListSVG className={styles.automationIcon} />
                {hasSearchQuery && <SearchVisual className={styles.emptySearchIcon} />}
            </div>

            <Title skin="h4" textColor="primary-700">
                {hasSearchQuery
                    ? texts.empty_search_title.replace('<QUERY>', searchValue)
                    : getEmptyStateTitle(type)}
            </Title>

            {supportAI && !hasSearchQuery ? (
                <Text tag="p" skin="paragraph-1" fontWeight="normal" textColor="secondary-500">
                    {aiTexts.ai_empty_state_promotion_text}
                </Text>
            ) : (
                <Text tag="p" skin="paragraph-1" fontWeight="normal" textColor="primary-700">
                    {hasSearchQuery ? texts.empty_search_text : getEmptyStateText(type)}
                </Text>
            )}
        </div>
    );
};
